import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { MediaLabel } from '..';
import { VideoFill } from '@wix/wix-ui-icons-common/on-stage';

visualize('MediaLabel', () => {
  story('simple', () => {
    snap('icon with text', <MediaLabel text="14:30" icon={<VideoFill />} />);
    snap('text only', <MediaLabel text="14:30" />);
    snap('icon only', <MediaLabel icon={<VideoFill />} />);
    snap(
      'rtl',
      <div dir="rtl">
        <MediaLabel text="14:30" icon={<VideoFill />} />
      </div>,
    );
  });
});
